<template>
  <section class="section">
    <div class="columns">
      <div class="column">
        <div class="title is-4">{{ page.name }}</div>
      </div>
      <div class="column">
        <div class="is-pulled-right">
          <button class="button is-info is-rounded mr-2" @click="refresh">
            <span class="icon">
              <i class="fa fa-refresh"></i>
            </span>
            <span>{{ $t("refresh") }}</span>
          </button>
          <button class="button is-success is-rounded mr-2" @click="save">
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("save") }}</span>
          </button>
          <!-- <button class="button is-warning is-rounded" @click="preview">
        <span class="icon">
          <i class="fa fa-eye"></i>
        </span>
        <span>{{ $t("preview") }}</span>
      </button> -->
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-one-quarter">
        <FileTree :tree="page" @file_selected="onFileSelected" />
      </div>
      <div class="column">
        <VueMonacoEditor
          v-model:value="file_content"
          language="html"
          height="600px"
          theme="vs-dark"
          :options="{
            automaticLayout: true,
            formatOnType: true,
            formatOnPaste: true,
            tabSize: 2,
            scrollBeyondLastLine: false,
            folding: true,
            bracketPairColorization: true,
            autoClosingBrackets: 'always',
            autoIndent: 'full',
          }"
        />
      </div>
    </div>
    <!-- <pre>{{ page }}</pre> -->
    <!-- <div class="columns is-multiline mt-4">
      <div class="column is-one-third" v-for="itm in content" :key="itm.name">
        <div class="card">
          <div class="card-content">
            <a class="title is-6" @click="edit_page(itm)">{{ itm.name }}</a>
            <p class="subtitle mb-1">{{ $t(itm.type) }}</p>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
import FileTree from "./FileTree.vue";

import {
  error_message,
  success_message,
  get,
  post,
  translate_file_size,
} from "@/utils";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";

export default {
  name: "LandingEdit",
  components: {
    VueMonacoEditor,
    FileTree,
  },
  data() {
    return {
      page: {},
      file_content: "",
      file_path: "",
    };
  },
  methods: {
    translate_file_size,
    refresh() {
      let v = this;
      v.$root.loader(true);
      get("/landing/page", { name: v.$route.params.uuid })
        .then((response) => {
          v.page = response;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    preview() {
      /** show html in new window */
      let v = this;
      if (!v.template.message) {
        error_message(v.$t("html code is empty"));
        return;
      } else {
        let html = v.template.message;
        let newWindow = window.open("", "_blank");
        newWindow.document.write(html);
        newWindow.document.close();
      }
    },
    save() {
      let v = this;
      v.$root.loader(true);
      post("/landing/page/file", {
        path: v.file_path,
        content: v.file_content,
      })
        .then((response) => {
          success_message(v.$t("file saved successfully"));
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    onFileSelected(file) {
      let v = this;
      v.$root.loader(true);
      get("/landing/page/file", { path: file.path })
        .then((response) => {
          v.file_content = response;
          v.file_path = file.path;
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  mounted() {
    this.refresh();
  },
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
